import Image from "next/image";
import IconDoubleCheck from "@/app/(components)/generics/Icons/IconDoubleCheck";
import { useT } from "@/app/translations/useT";
import { ConceptFlowMessage } from "@/app/types/home/ConceptFlow";
import { FLOW_AVATAR_SIZE } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";

type Props = {
  message: ConceptFlowMessage;
};

export default function ConceptFlowMessageBubble(props: Props) {
  const { message } = props;
  const T = useT();

  return (
    <div className={`${styles.messageRow} ${message.isOutgoing ? styles.messageRowOut : ""}`}>
      <Image
        className={styles.messageAvatar}
        src={message.photo}
        alt=""
        width={FLOW_AVATAR_SIZE}
        height={FLOW_AVATAR_SIZE}
        unoptimized
      />
      <div className={styles.messageContent}>
        <p
          className={`${styles.bubble} ${message.isOutgoing ? styles.bubbleOut : styles.bubbleIn}`}
        >
          {T(message.textKey)}
        </p>
        <span className={styles.messageMeta}>
          {message.time}
          {message.isOutgoing && (
            <span className={styles.messageTicks}>
              <IconDoubleCheck />
            </span>
          )}
        </span>
      </div>
    </div>
  );
}
